export default __webpack_public_path__ + "static/media/mexico_flag.8037ab70.svg";